import { useEffect, useState } from "react";
import "./Home.css";
import Loader from "../../Loader";
export default function Home() {
  const [name, setName] = useState(null);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function getData() {
      const response = await fetch(`${process.env.REACT_APP_server}/home`);
      let profile = await response.json();

      setName(Array.from(profile[0].name));
      setDescription(profile[0].description);
      setTitle(profile[0].title);
      setImageURL(profile[0].imageURL);
      setIsLoading(false);
    }

    getData();
  }, []);

  console.log(isLoading);
  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div class="container">
          <div className="home">
            <div className="flex-1">
              <div className="image">
                <img className="img" src={imageURL} alt="img"></img>
              </div>

              <h1 className="text">Hi I'm,</h1>
              <h1 className="name__profile">
                <span></span>
                <span>{name}</span>
              </h1>

              <div className="flex-2">
                <h2 className="title">{title}</h2>
                <p className="description">{description}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
